module.exports = __webpack_public_path__ + "static/media/wmsui32_3920.e7a23320.ico";